import { RoleFragment } from '../../graphql/generated';

export type RolePermissionsMap = Record<string, string>;

/**
 * Maps the roles to its raw permissions
 */
export const createRolePermissionsMap = (
  roles: RoleFragment[]
): RolePermissionsMap => {
  return roles.reduce(
    (acc, role) => ({ ...acc, [role.id]: role.rawPermissions }),
    {}
  );
};
